export const handleError: TimApp.AppHandleErrorFunc = (error) => {
  // todo: better error handling
  console.error(error);
};
